module.exports = __webpack_public_path__ + "img/close_square.b5ded093.svg";